import React from "react";

const AboutUs = () => {
  return (
    <div className="container" style={{ color: '#EEEEF0' }}>

      <header className="header">
        <h1 className="text-center title">About Us</h1>
      </header>
      <p className="">Welcome to <a href="https://goldcleats.ai" target="_blank" rel="noopener noreferrer" style={{ color: '#EEEEF0' }}>GoldCleats.ai</a>: Revolutionizing the Future of Soccer Data and Discovery</p>
      <p>
        <a href="https://goldcleats.ai" target="_blank" rel="noopener noreferrer" style={{ color: '#EEEEF0' }}>GoldCleats.ai</a> is the world’s most advanced soccer search engine, powered by cutting-edge AI. As the digital home of the
        GoldCleats Player Video Library, we leverage an exclusive, proprietary data feed from the largest youth soccer dataset on the planet.
        By combining this unparalleled resource with GPU-enabled Large Language Models (LLMs), we bring the game to life like never before.
      </p>
      <p>
        Our mission is simple: to empower the next generation of soccer stars, scouts, and enthusiasts by centralizing the tools, technology,
        and insights that matter most. With deep roots in youth soccer communities and elite academy systems, we’ve built a platform that
        caters to everyone—from aspiring players to industry-leading professionals.
      </p>

      <h2 className="mt-4">Our Data is Our Edge</h2>
      <p>
        <a href="https://goldcleats.ai" target="_blank" rel="noopener noreferrer" style={{ color: '#EEEEF0' }}>GoldCleats.ai</a> harnesses a unique blend of player video data, community insights, and IoT-enabled tracking technologies to produce
        actionable intelligence. This isn’t just data; it’s the blueprint for the game’s future. Our AI scrapes, processes, and analyzes
        the most comprehensive dataset in youth soccer, creating connections and opportunities at scale. Whether you’re identifying emerging
        talent or breaking down performance metrics, our platform delivers.
      </p>

      <h2 className="mt-4">Technology Meets Talent</h2>
      <p>
        Imagine an AI so powerful it can uncover the next big star before the world even knows their name. That’s what we’ve built.
      </p>
      <ul>
        <li>
          <strong>Generative AI-Driven Tools:</strong> Our AI solutions are tailored to help stakeholders in the soccer ecosystem make smarter decisions, faster.
        </li>
        <li>
          <strong>Video Analysis and Hosting:</strong> Our platform integrates tools for editing, storage, and sharing.
        </li>
        <li>
          <strong>IoT and Biometric Tracking:</strong> Link real-world performance data to dynamic insights for players, coaches, and scouts.
        </li>
      </ul>

      <h2 className="mt-4">A Player-First Vision</h2>
      <p>
        At <a href="https://goldcleats.ai" target="_blank" rel="noopener noreferrer" style={{ color: '#EEEEF0' }}>GoldCleats.ai</a>, we are more than a technology company—we are a community. With the world’s largest network of verified youth academy
        prospects and scouts, we empower players at every level to reach their full potential.
      </p>
      <p>
        From discovering talent in remote corners of the globe to elevating academy players into the professional spotlight,
        <a href="https://goldcleats.ai" target="_blank" rel="noopener noreferrer" style={{ color: '#EEEEF0' }}>GoldCleats.ai</a> is the bridge that connects dreams with reality.
      </p>

      <h2 className="mt-4">Global Scale, Local Impact</h2>
      <p>
        With partnerships spanning elite clubs, leagues, and soccer academies worldwide, our reach is unmatched. From MLS NEXT programs in
        the U.S. to tech-driven talent initiatives in Rio and London, <a href="https://goldcleats.ai" target="_blank" rel="noopener noreferrer" style={{ color: '#EEEEF0' }}>GoldCleats.ai</a> is shaping the global game.
      </p>
      <p>
        Our platform isn’t just a tool; it’s the future of soccer as we know it. And the future is here.
      </p>
      <p>
        Join us as we redefine how the world sees, plays, and dreams about the beautiful game. 
        Welcome to the <a href="https://goldcleats.ai" target="_blank" rel="noopener noreferrer" style={{ color: '#EEEEF0' }}>GoldCleats.ai</a> revolution.
      </p>
    </div>

  );
};

export default AboutUs;
